import React from 'react';
import Loadable from 'react-loadable';
import Helmet from 'react-helmet';

const AsyncExploreForYouRoute = Loadable({
  loader: () =>
    import(/* webpackChunkName: "explore_for_you" */ './AsyncExploreForYouRoute.js'),
  loading: () => (
    <Helmet bodyAttributes={{ style: 'background-color: white;' }} />
  )
});

export default AsyncExploreForYouRoute;
